import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchUsers(params) {
  return await request({
    url: ENDPOINT.USER_MANAGEMENT,
    method: "get",
    params,
  });
}


export async function updateUserStatus(id, data) {
  return await request({
    url: `${ENDPOINT.USER_MANAGEMENT}/${id}`,
    method: "post",
    data,
  });
}
